import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import {createSelector} from 'reselect';
import {push} from 'react-router-redux';

import * as styles from '../../styles';
import PaginatedContainer from '../../paginator/paginated_container';
import {request} from '../../containers/actions';
import {refresh as paginatorRefresh, clearSelection, updateItem} from '../../paginator/actions';


export default class FreeStoreItems extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
        user: PropTypes.object,
    }

    static propTypes = {
        readonly: PropTypes.bool,
        selectable: PropTypes.bool,
        actions: PropTypes.array,
        buttonActions: PropTypes.array,
    }

    static defaultProps = {
        readonly: false,
        selectable: true,
        actions: [],
        buttonActions: [],
    }

    listFields = [
        {field: 'id', label: window.gettext('ID')},
        {field: 'description', label: window.gettext('Description')},
        {field: 'price', label: window.gettext('Price')},
        {field: 'weight', label: window.gettext('Weight')},
        {
            field: item => item.off ? <span style={{color: 'red'}}>{'%' + item.off.persian()}</span> : null,
            label: window.gettext('Off'),
        },
        {
            field: item => <div
                style={{
                    backgroundColor: item.supply_in_store
                        ? styles.successBackColor
                        : styles.warningBackColor,
                    color: item.supply_in_store
                        ? styles.successColor
                        : styles.warningColor,
                    borderColor: item.supply_in_store
                        ? styles.successBorderColor
                        : styles.warningBorderColor,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '2em',
                }}
                className={item.supply_in_store ? 'fa-check' : 'fa-times'}>
            </div>,
            label: window.gettext('Supply in store'),
        },
        {
            field: item => <span style={{display: 'inline-block', width: '10em'}}>
                <span style={{display: 'inline-block', width: '3.5em', textAlign: 'center'}}>
                    {item.stock.persian()}
                </span>
                &nbsp;
                <button
                    style={{
                        ...styles.button,
                        backgroundColor: 'transparent',
                        padding: '.5em',
                        boxSizing: 'border-box',
                        minWidth: undefined,
                    }}
                    onClick={async event => {
                        event.stopPropagation();
                        const amount = prompt(window.gettext('Enter amount to increase:')).english();
                        if (String(Number(amount)) !== amount)
                            return;
                        const response = await this.context.store.dispatch(request({
                            path: `/store-item/${item.id}/increase_stock/`,
                            body: {amount},
                            method: 'PATCH',
                        }));
                        this.context.store.dispatch(updateItem(response, this.props.store.getIn(['paginator', 'elementId'])));
                    }}
                    onMouseUp={({target}) => target.blur()}>
                    <i className='fa-plus fa-lg'></i>
                </button>
                <button
                    style={{
                        ...styles.button,
                        backgroundColor: 'transparent',
                        padding: '.5em',
                        boxSizing: 'border-box',
                        minWidth: undefined,
                    }}
                    onClick={async event => {
                        event.stopPropagation();
                        const amount = prompt(window.gettext('Enter amount to increase:')).english();
                        if (String(Number(amount)) !== amount)
                            return;
                        const response = await this.context.store.dispatch(request({
                            path: `/store-item/${item.id}/increase_stock/`,
                            body: {amount: -Number(amount)},
                            method: 'PATCH',
                        }));
                        this.context.store.dispatch(updateItem(response, this.props.store.getIn(['paginator', 'elementId'])));
                    }}
                    onMouseUp={({target}) => target.blur()}>
                    <i className='fa-minus fa-lg'></i>
                </button>
            </span>,
            label: <span style={{display: 'inline-block', width: '10em', textAlign: 'center'}}>{window.gettext('Stock')}</span>,
        },
        {field: 'sold', label: window.gettext('Sold')},
        {
            field: item => <button
                style={{
                    ...styles.button,
                    backgroundColor: 'transparent',
                    padding: '.25em',
                    boxSizing: 'border-box',
                }}
                onClick={async event => {
                    event.stopPropagation();
                    this.context.store.dispatch(push('/store/orders/?item=' + item.id));
                }}
                onMouseUp={({target}) => target.blur()}>
                {window.gettext('Sell Report')}
            </button>
            ,
        },
    ]

    filters = [
        {
            field: 'item',
            selected: {'-': null},
        },
    ]

    sorts = [
        {name: 'id', label: window.gettext('id')},
    ]

    actionsSelector = createSelector(
        [
            () => this.props.actions,
            () => this.props.readonly,
            () => this.props.store.getIn(['paginator', 'selected']).size > 0,
        ],
        () => this.props.readonly
            ? this.props.actions
            : this.props.store.getIn(['paginator', 'selected']).size === 0
                ? this.props.actions
                : _.concat(
                    this.props.actions,
                    [
                        {
                            label: window.gettext('Supply in store'),
                            action: async () => {
                                if (!window.confirm(window.interpolate(
                                    window.gettext('Are you sure you wanna supply these %(count)s items in store?'),
                                    {count: this.props.store.getIn(['paginator', 'selected']).size.persian()},
                                    true,
                                )))
                                    return;
                                await this.context.store.dispatch(request({
                                    path: '/store-item/',
                                    body: this.props.store.getIn(
                                        ['paginator', 'selected'],
                                    ).map((comment, id) => ({id, supply_in_store: true})).toArray(),
                                    method: 'PATCH',
                                }));
                                this.context.store.dispatch([
                                    clearSelection(this.props.store.getIn(['paginator', 'elementId'])),
                                    paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])),
                                ]);
                            },
                        },
                        {
                            label: window.gettext('Remove from store'),
                            action: async () => {
                                if (!window.confirm(window.interpolate(
                                    window.gettext('Are you sure you wanna remove these %(count)s items from store?'),
                                    {count: this.props.store.getIn(['paginator', 'selected']).size.persian()},
                                    true,
                                )))
                                    return;
                                await this.context.store.dispatch(request({
                                    path: '/store-item/',
                                    body: this.props.store.getIn(
                                        ['paginator', 'selected'],
                                    ).map((comment, id) => ({id, supply_in_store: false})).toArray(),
                                    method: 'PATCH',
                                }));
                                this.context.store.dispatch([
                                    clearSelection(this.props.store.getIn(['paginator', 'elementId'])),
                                    paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])),
                                ]);
                            },
                        },
                    ],
                )
    )

    buttonActionsSelector = createSelector(
        [
            () => this.props.buttonActions,
            () => this.props.readonly,
        ],
        () => this.props.readonly
            ? this.props.buttonActions
            : _.concat(this.props.buttonActions, [
                {
                    label: window.gettext('Add Goods'),
                    action: () => this.context.store.dispatch(push(
                        this.context.store.getState().getIn(
                            ['routing', 'locationBeforeTransitions', 'pathname'],
                        ) + 'add/',
                    )),
                },
            ])
    )

    componentDidUpdate(prevProps) {
        if (prevProps.params.id && !this.props.params.id) {
            this.context.store.dispatch(paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])));
        }
    }

    render() {
        return <PaginatedContainer
            store={this.props.store.get('paginator')}
            resource='store-item'
            title={window.gettext('Free Store Items')}
            listFields={this.listFields}
            selectable={this.props.selectable}
            filters={this.filters}
            sorts={this.sorts}
            pageSize={this.props.pageSize}
            active={this.props.params.id}
            buttonActions={this.buttonActionsSelector(this.props.store)}
            actions={this.actionsSelector(this.props.store)}
        />;
    }
}
